function normalizeRoleValue(value: string | null | undefined): string {
	if (typeof value !== "string") {
		return "";
	}
	return value
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.toLowerCase()
		.replace(/['_\-\s]/g, "");
}

function roleIncludesAny(normalizedRole: string, candidates: string[]): boolean {
	return candidates.some((candidate) => normalizedRole.includes(candidate));
}

function normalizeRoleCandidates(candidates: string[]): string[] {
	return candidates.map((candidate) =>
		candidate
			.normalize("NFD")
			.replace(/[\u0300-\u036f]/g, "")
			.toLowerCase()
			.replace(/['_\-\s]/g, ""),
	);
}

export function roleNameEqualsOneOf(roleName: string | null | undefined, expectedNames: string[]): boolean {
	const normalizedRole = normalizeRoleValue(roleName);
	if (!normalizedRole || expectedNames.length === 0) {
		return false;
	}
	const normalizedExpected = normalizeRoleCandidates(expectedNames);
	return normalizedExpected.includes(normalizedRole);
}

export function isAdminRole(globalRole: string | null | undefined): boolean {
	return normalizeRoleValue(globalRole) === "admin";
}

export function isGlobalAdminRole(globalRole: string | null | undefined): boolean {
	const normalized = normalizeRoleValue(globalRole);
	return normalized === "admin" || normalized === "superadmin";
}

export function isSuperAdminRole(globalRole: string | null | undefined): boolean {
	const normalized = normalizeRoleValue(globalRole);
	return normalized === "superadmin";
}

export function isOfficeAdminRole(
	globalRole: string | null | undefined,
	officeRoleName: string | null | undefined,
): boolean {
	const normalizedGlobal = normalizeRoleValue(globalRole);
	if (normalizedGlobal === "admin") {
		return true;
	}
	const normalizedOfficeRole = normalizeRoleValue(officeRoleName);
	return roleIncludesAny(normalizedOfficeRole, [
		"admin",
		"gestionnaire",
		"responsable",
		"notaire",
		"associe",
		"titulaire",
	]);
}
